import React, { useState } from "react";

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <h1 className="logo">MyWebsite</h1>

        {/* Hamburger button */}
        <button
          className="hamburger"
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </button>

        {/* Navigation links */}
        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>

      <style>{`
        .navbar {
          background: #333;
          color: #fff;
          padding: 10px 20px;
        }
        .nav-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .nav-links {
          display: flex;
          list-style: none;
          gap: 20px;
        }
        .nav-links a {
          color: #fff;
          text-decoration: none;
        }
        .hamburger {
          display: none;
          font-size: 24px;
          background: none;
          border: none;
          color: #fff;
          cursor: pointer;
        }

        /* Mobile styles */
        @media (max-width: 768px) {
          .hamburger {
            display: block;
          }
          .nav-links {
            display: none;
            flex-direction: column;
            background: #444;
            position: absolute;
            top: 60px;
            right: 20px;
            padding: 10px;
            border-radius: 8px;
          }
          .nav-links.open {
            display: flex;
          }
        }
      `}</style>
    </nav>
  );
};

export default Menu;
